import { render, staticRenderFns } from "./useRatioConfig.vue?vue&type=template&id=0c6a88ce&scoped=true"
import script from "./useRatioConfig.vue?vue&type=script&lang=js"
export * from "./useRatioConfig.vue?vue&type=script&lang=js"
import style0 from "./useRatioConfig.vue?vue&type=style&index=0&id=0c6a88ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6a88ce",
  null
  
)

export default component.exports